import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { GlobalStyles } from "./components/GlobalStyled/GlobalStyled";
import ProtectedRoute from "./utils/protectedRoute";
import OpenRoute from "./utils/openRoute";
import "antd/dist/antd.css"; // or 'antd/dist/antd.less'

function App() {
  const token = localStorage.getItem("token");
  return (
    <Router>
       {/* <UserState>*/}
          <GlobalStyles />
          {!token ? <OpenRoute /> : <ProtectedRoute />}
          
        {/* </UserState> */}
    </Router>
  )
}

export default App;
